<template>
    <div>
      <p>Hello Testing {{evenNumber}}</p>
        <vs-button @click="methodClick()">Button</vs-button>
    </div>
    
</template>

<script>
export default {
  data () {
    return {
      evenNumber:0
    }
  },
  methods:{
    methodClick () {
      this.evenNumber++
      console.log('hi')
    }
  },
  watch:{
    evenNumber () {
      console.log(`Even${this.evenNumber}`)
    }
  }
}

</script>

<style scoped>
/* div{
  margin: 5px;
} */
</style>